app.service('textFormatService', [function () {
    var that = this;

    that.sanatize = function (text) {
        return text.replace('&', '%26')
                   .replace('+', '%2B');
    }
}]);